export interface WindowDimensions {
  width: number;
  height: number;
}

interface Position {
  top: number;
  left: number;
  right: number;
  bottom: number;
}

const cache: WindowDimensions = {
  width: null,
  height: null,
};

class ViewportService {
  tryCachedReturn(): WindowDimensions {
    return cache.width && cache.height ? cache : this.getSize();
  }

  getSize(): WindowDimensions {
    const $scope = window;
    cache.width = $scope.innerWidth;
    cache.height = $scope.innerHeight;
    return {
      width: cache.width,
      height: cache.height,
    };
  }

  getPosition(element: HTMLElement): Position {
    const rect = element.getBoundingClientRect();

    return {
      top: Math.round(rect.top),
      right: Math.round(rect.right),
      bottom: Math.round(rect.bottom),
      left: Math.round(rect.left),
    };
  }

  isVisible(element: HTMLElement, OFFSET = 0): boolean {
    const viewport = this.tryCachedReturn();
    const position = this.getPosition(element);

    return (
      (position.top >= -OFFSET && position.top <= viewport.height + OFFSET) ||
      (position.bottom >= -OFFSET &&
        position.bottom <= viewport.height - OFFSET)
    );
  }
}

// const instance = new ViewportService();
export { ViewportService };
